import {
    StoryPreviewFragment,
    StoryToPlayFragment,
} from '@graphql/generated/graphql';
import { createContext, FC, PropsWithChildren, useContext } from 'react';

import { SanitizedStoryPage } from '../types';

interface NavigationContext {
    module?: string;
    story?: StoryToPlayFragment;
    storyPages: SanitizedStoryPage[];
    previousStory?: StoryPreviewFragment;
    nextStory?: StoryPreviewFragment;
}

interface Props extends PropsWithChildren, NavigationContext {}

const partialInitialContext: NavigationContext = {
    module: undefined,
    story: undefined,
    storyPages: [],
};

export const NavigationContext = createContext<NavigationContext>(
    partialInitialContext
);

export const NavigationProvider: FC<Props> = ({
    children,
    module,
    story,
    storyPages,
    previousStory,
    nextStory,
}) => {
    const initialContext = {
        ...partialInitialContext,
        module,
        story,
        storyPages,
        previousStory,
        nextStory,
    };

    return (
        <NavigationContext.Provider value={initialContext}>
            {children}
        </NavigationContext.Provider>
    );
};

export const useNavigationContext = () =>
    useContext<NavigationContext>(NavigationContext);
